import req from './apis'
import { service_url } from './getDomain'

export function shopping_trolley_list(body) {
    return req.get({
        url: service_url + '/user/cart/queryByUser',
        body
    }).then(function (data) {
        return data
    })
}
export function shopping_trolley_submit_order(body) {
    return req.get({
        url: service_url + '/user/order/prepareCheckout',
        body
    }).then(function (data) {
        return data
    })
}
export function cart_queryByUsers(body) {
    return req.get({
        url: service_url + '/user/cart/queryByUser',
        body
    }).then(function (data) {
        return data
    })
}
export function add_order(body) {
    return req.postJson({
        url: service_url + '/user/cart/add',
        body
    }).then(function (data) {
        return data
    })
}
export function save(body) {
    return req.postForm({
        url: service_url + '/user/order/save',
        body
    }).then(function (data) {
        return data
    })
}

export function addCart(body) {     // 新增收货地址
    return req.postJson({
        url: service_url + '/user/address/save',
        body
    }).then(function (data) {
        return data
    })
}
export function queryByUser(body) {      // 查询地址列表
    return req.get({
        url: service_url + '/user/address/queryByUser',
        body
    }).then(function (data) {
        return data
    })
}


// this.$service.roster_list({
//
// }).then(res => {

// })
